<template>
    <!-- 集中檢核 資料與他人重複提示燈箱 -->
    <PopupBase
        v-model:visiblePopup="visibleCheckPopup"
        modalWidth="max-w-[90%] xs:max-w-[50rem]"
        :params="{
            title: `${ data.fullPolicyNo } 給付帳號明細`,
            cancelButton: '關閉',
        }"
        closeicon
        :needDivide="false"
        @handleClose="closePopup"
        @cancel="closePopup"
    >
        <template #content>
            <div class="hidden sm:block w-full">
                <TableBase
                    :cursorPointer="false"
                    isBorder
                    class="w-full -my-3"
                >
                    <template #thead>
                        <tr>
                            <th class="px-4 py-2  w-1/4">
                                受益人
                            </th>
                            <th class="px-4 py-2  w-1/3">
                                銀行
                            </th>
                            <th class="px-4 py-2">
                                帳號
                            </th>
                        </tr>
                    </template>
                    <template #tbody>
                        <tr class="text-gray-900">
                            <td class="px-4 py-3 break-all align-top">
                                <template v-if="data.paidId">
                                    <p>{{ data.paidId }}</p>
                                    <p>{{ data.paidName }}</p>
                                </template>
                                <p v-else>
                                    未指定
                                </p>
                            </td>
                            <td class="px-4 py-3 break-all align-top">
                                <template v-if="data.bnkId">
                                    <p>{{ data.bnkId }}{{ data.bnkSubNo }}</p>
                                    <p>{{ data.bnkNm }}</p>
                                </template>
                                <p v-else>
                                    未指定
                                </p>
                            </td>
                            <td class="px-4 py-3 break-all align-top">
                                <p>{{ data.bnkAcct ? data.bnkAcct : '未指定' }}</p>
                            </td>
                        </tr>
                    </template>
                </TableBase>
            </div>
        </template>
    </PopupBase>
</template>

<script>
import { ref, watch } from 'vue';
import PopupBase from '@/components/dialogs/Popup.vue';
import TableBase from '@/components/table/TableBase.vue';

export default {
    components: {
        PopupBase,
        TableBase
    },
    props: {
        isPopup: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            required: true
        }
    },
    emits: ['update:isPopup'],
    setup(props, { emit }) {
        const checkBDPMessage = ref('');
        const visibleCheckPopup = ref(false);

        /** 資料燈箱關閉 */
        const closePopup = () => {
            emit('update:isPopup', false);
        };

        /** 確認輸入資料是否與他人重複 */
        watch(() => props.isPopup, (newV) => {
            visibleCheckPopup.value = newV;
        }, { immediate: true, deep: true });

        return {
            checkBDPMessage,
            closePopup,
            visibleCheckPopup
        };
    },
};
</script>
